import * as React from 'react';
import styled, { useTheme } from 'styled-components/macro';
import { ModalAddContact } from 'lib/components/modal/ModalAddContact';

import { MdAdd } from 'react-icons/md';
import { IoIosLogIn } from 'react-icons/io';
import placeholder from 'assets/images/table/placeholderBig.webp';
import { Button } from 'react-covideo-common';
import { useTranslation } from 'react-i18next';

const NoContactLayout = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 450px;
  background-image: url(${placeholder});
  background-repeat: no-repeat;
  background-size: cover;
`;

const Text = styled.p`
  font-size: 18px;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.black[100]};
  text-align: center;
  margin-bottom: 32px;
`;
const Row = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
`;
type Props = {
  handleAddContact: (
    newContacts: object,
    updatedContacts: object,
    updatedGroupsOnlyContacts: object
  ) => void;
};

export const NoContacts = ({ handleAddContact }: Props) => {
  const { t } = useTranslation();
  const { colors } = useTheme();
  const [isUploadVisible, setIsUploadVisible] = React.useState(false);
  const [isCreateVisible, setIsCreateVisible] = React.useState(false);

  return (
    <>
      {isUploadVisible && (
        <ModalAddContact
          modalType='bulk'
          title={t('Import Contacts')}
          text=''
          handleModalClose={() => setIsUploadVisible(false)}
          handleSubmit={handleAddContact}
        />
      )}

      {isCreateVisible && (
        <ModalAddContact
          modalType='one'
          title={t('Add Contact')}
          text=''
          handleModalClose={() => setIsCreateVisible(false)}
          handleSubmit={handleAddContact}
        />
      )}
      <NoContactLayout>
        <Text>{t('You have no contacts')}</Text>
        <Row>
          <Button
            text={t('Create')}
            onClick={() => {
              setIsCreateVisible(true);
            }}
            icon={<MdAdd color={colors.white[100]} />}
          />
          <Button
            variant='ghost'
            icon={<IoIosLogIn color={colors.black[100]} />}
            text={t('Import')}
            onClick={() => {
              setIsUploadVisible(true);
            }}
          />
        </Row>
      </NoContactLayout>
    </>
  );
};
